(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["VIDEO-CON-TEXTO"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reproducirVideo(video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.autoplay = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    var intento = video.play();
    if (intento !== undefined) {
      intento.catch(function () {
        video.addEventListener(
          'canplay',
          function () {
            video.play().catch(function () {});
          },
          { once: true }
        );
      });
    }
  }

  function iniciar() {
    document.querySelectorAll('.bloque-video-texto__video').forEach(function (video) {
      if (video.readyState >= 2) {
        reproducirVideo(video);
      } else {
        video.addEventListener(
          'loadedmetadata',
          function () {
            reproducirVideo(video);
          },
          { once: true }
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contadorclientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatearNumero(numero, separador) {
      numero = Math.round(numero);
      if (separador === 'none') {
        return String(numero);
      }
      return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separador === 'coma' ? ',' : '.');
    }

    function iniciarContador(elemento) {
      if (!elemento || elemento.dataset.contadorAnimado === 'true') return;
      elemento.dataset.contadorAnimado = 'true';

      var inicio = parseInt(elemento.getAttribute('data-numero-inicio'), 10) || 0;
      var final = parseInt(elemento.getAttribute('data-numero-final'), 10) || 0;
      var duracion = parseInt(elemento.getAttribute('data-duracion'), 10) || 2000;
      var separador = elemento.getAttribute('data-separador') || 'punto';
      var tiempoInicio = null;

      function paso(marcaTiempo) {
        if (!tiempoInicio) tiempoInicio = marcaTiempo;
        var progreso = Math.min((marcaTiempo - tiempoInicio) / duracion, 1);
        var progresoSuavizado = 1 - Math.pow(1 - progreso, 3);
        var valorActual = inicio + (final - inicio) * progresoSuavizado;
        elemento.textContent = formatearNumero(valorActual, separador);
        if (progreso < 1) {
          window.requestAnimationFrame(paso);
        } else {
          elemento.textContent = formatearNumero(final, separador);
        }
      }

      window.requestAnimationFrame(paso);
    }

    function inicializarSeccion(seccion) {
      var elementos = seccion.querySelectorAll('[data-contador-numero-' + seccion.dataset.sectionId + ']');
      if (!elementos.length) return;

      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              entrada.target.querySelectorAll
                ? iniciarContador(entrada.target)
                : null;
            }
          });
        },
        { threshold: 0.4 }
      );

      elementos.forEach(function (el) {
        observador.observe(el);
      });
    }

    document.querySelectorAll('.contador-clientes-seccion').forEach(function (seccion) {
      inicializarSeccion(seccion);
    });

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('.contador-clientes-seccion');
      if (seccion) inicializarSeccion(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
